// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__YfhFc","inner":"Form_inner__WV85L","range":"Form_range__33o5b","name":"Form_name__25RKx","actions":"Form_actions__7HElY"};